module.exports = __webpack_public_path__ + "assets/img/pair_ensemble_1.e2c46fc4.svg";